// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"547":"64f8dbec","6186":"64f8dbec","6353":"64f8dbec"}[chunkId] + ".chunk.css";
};